import React, { useState, useEffect } from 'react';
import { Form, Input, Select, InputNumber, Button, Card, message, Table, Modal, Space, Tag } from 'antd';
import { Badge } from 'react-bootstrap';
import Icon, {
    SearchOutlined,
    PlusOutlined,
    DollarOutlined,
    UserOutlined,
    SwapOutlined,
    CalendarOutlined,
    EditOutlined,
    DeleteOutlined,
} from '@ant-design/icons';
import '../../assets/styles/dashboard.css';
import AddIncomeModel from './Components/AddIncomModel';
import ImageShow from '../../Uitiles/ImageShow';
import { oneKlicks } from '../../SDK/oneclick';
import { OneKlicksFileSDK } from '../../SDK/OneKlicksFileSDK';
import { auto } from '@popperjs/core';
import EditIncomModel from './Components/EditIncomModel';
import ConfirmationModal from '../Components/ConfirmationModal';
import CheckName from './Components/CheckName';
import deleteBalanceSheet from '../../Uitiles/DelectBalanceSeet';
import { debugInfo, debugLog } from '../../utils/debug';
import Paginationnew from '../../Uitiles/Paginationnew';

// Add custom styles for hiding scrollbar
const hideScrollbarStyle = {
    maxHeight: '80vh',
    overflowY: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
};

const IncomeManagement = () => {
    const [form] = Form.useForm();
    const [transactionType, setTransactionType] = useState('');
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [editIncome, setEditIncome] = useState(false);
    const [editIncomeModel, setEditIncomeModel] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [incomeType, setIncomeType] = useState('');
    const [mockData, setMockData] = useState([]);
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [limit, setLimit] = useState(10);
    const [status, setStatus] = useState('');
    const [filterdeportment, setfilterdeportment] = useState('');
    const [clients, setClients] = useState([]);
    useEffect(() => {

        fetchIncome();
        fetchClients();
    }, []);

    useEffect(() => {
        fetchIncome();
    }, [status, incomeType, filterdeportment, searchText, page]);

    const handleAddInvoiceItem = () => {
        setIsModalVisible(true);
    };


    const fetchClients = async () => {
        try {
            const tableSchema = "";
            const tableName = "users";
            const conditions = {};
            const orderBy = "id DESC";
            const search = {};
            const pagination = {};
            const margedata = [];
            const clients = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            if (clients.success === true) {
                setClients(clients.data);
            }
        } catch (error) {
            console.error('Error fetching clients:', error);
        }
    };

const fetchIncome = async () => {
    try {
        const tableSchema = "";
        const tableName = "income";
        const conditions = {
            ...(status ? { status: status } : {}),
            ...(incomeType ? { incomeType: incomeType } : {}),
            ...(filterdeportment ? { add_by: filterdeportment } : {})
        };
        const orderBy = 'id DESC';
        const search = searchText ? {
            amount: searchText,
            add_by: searchText,
            date: searchText,
            description: searchText,
            incomeType: searchText,
            investorEmail: searchText,
            investorName: searchText,
            investorPhone: searchText,
        } : {};
        const pagination = {
            page: page,
            limit: limit
        };
        const margedata = [
            {
                "target_table": "users",
                "target_column": "id",
                "target_value": "add_by",
                "target_label": "user_details"
            },
            {
                "target_table": "users",
                "target_column": "id",
                "target_value": "clientYes",
                "target_label": "client_details"
            }
        ];
        const income = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
        debugLog('income', income);

        if (income.success === true) {
            setMockData(income.data || []);
            setTotal(income.totalPages || 0);
        } else {
            console.error('Failed to fetch income:', income);
            setMockData([]);
            setTotal(0);
        }
    } catch (error) {
        console.error('Error fetching income:', error);
        setMockData([]);
        setTotal(0);
    }
};

const handlePageChange = (page) => {
    setPage(page);
    fetchIncome();
};



const handleEdit = (record) => {
    // Implement edit functionality
    debugLog('Edit record:', record);
    setEditIncome(record);
    setEditIncomeModel(true);

};

const handleDelete = (record) => {
    setSelectedRecord(record);
    setIsDeleteModalVisible(true);
};

const handleConfirmDelete = async () => {
    if (!selectedRecord) return;

    const tableSchema = '';
    const tableName = 'income';
    const conditions = { id: selectedRecord.id };

    try {
        const income = await oneKlicks.delete(tableSchema, tableName, conditions);
        debugLog('income', income);
        if (income.success === true) {
            await deleteBalanceSheet(selectedRecord.id);
            message.success('Income deleted successfully');

        } else {
            message.error('Failed to delete income.');
        }
    } catch (error) {
        debugLog('Delete error:', error);
        message.error('Something went wrong while deleting.');
    } finally {
        setIsDeleteModalVisible(false);
        setSelectedRecord(null);
        fetchIncome();
    }
};

const showModal = () => {
    setIsModalVisible(true);
};

const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
    setTransactionType(''); // Reset transaction type state
};

const handleFormSubmit = (e) => {
    e.preventDefault();
    fetchIncome();
};

return (
    <div className="dc-haslayout dc-dbsectionspace">

        <div className="container-fluid py-3">
            <div className="card mb-5">
                <div className="card-body">
                    <div className="align-items-center justify-content-between mb-3">
                        <div className="d-flex align-items-center gap-2  mb-2">
                            <h5 className="mb-0 font-weight-bold mr-3">Income</h5>
                            <Badge bg="badge bg-info">Management</Badge>
                        </div>
                        <div className="card-filter">
                            <form onSubmit={handleFormSubmit}>
                                <div className="filter-form">
                                    <div className="filter-item">
                                        <input
                                            type="text"
                                            autoComplete="off"
                                            name="search"
                                            placeholder="Search With Username"
                                            className="form-control"
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                        />
                                    </div>

                                    <div className="filter-item">
                                        <select
                                            name="status"
                                            className="form-select"
                                            value={status}
                                            onChange={(e) => setStatus(e.target.value)}
                                        >
                                            <option value="">Select Status</option>
                                            <option value="active">Active</option>
                                            <option value="pending">Pending</option>
                                            <option value="completed">Completed</option>
                                        </select>
                                    </div>

                                    <div className="filter-item">
                                        <select
                                            name="incomeType"
                                            className="form-select"
                                            value={incomeType}
                                            onChange={(e) => setIncomeType(e.target.value)}
                                        >
                                            <option value="">Select Income Type</option>
                                            <option value="investment">Investment</option>
                                            <option value="premium">Premium</option>
                                            <option value="client">Client</option>
                                            <option value="other">Other</option>
                                            <option value="invoice_payment">Invoice Payment</option>
                                        </select>
                                    </div>

                                    <div className="filter-item">
                                        <select
                                            name="status"
                                            className="form-select"
                                            search={true}
                                            value={filterdeportment}
                                            onChange={(e) => setfilterdeportment(e.target.value)}
                                        >
                                            <option value="">Select User</option>
                                            {clients.length > 0 ? (
                                                clients.map((data) => {
                                                    return (
                                                        <option key={data.id} value={data.id}>
                                                            {data.display_name} {/* Display only the domain name */}
                                                        </option>
                                                    );
                                                })
                                            ) : (
                                                <option disabled>No available</option>
                                            )}
                                        </select>
                                    </div>

                                    <div className="filter-action">
                                        <button
                                            type="button"
                                            className="i-btn danger--btn btn--md"
                                            onClick={() => { setSearchText(''); setStatus(''); setIncomeType(''); setPage(1); setfilterdeportment('') }}
                                        > 
                                        <i class="las la-sync"></i>
                                            Reset
                                        </button>

                                        {/* Add New Button */}
                                        <button
                                            type="button"
                                            className="i-btn primary--btn btn--md text-white"
                                            onClick={handleAddInvoiceItem}
                                        >
                                            Add New Income
                                        </button>

                                    </div>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
            <div className="card">
                <div className="card-body">
                    <div className="table-responsive">
                        <table className="table table-hover table-striped" >
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Added By</th>
                                    <th>Client</th>
                                    <th>Amount</th>
                                    <th>Transfer Type</th>
                                    <th>Income Type</th>
                                    <th>Description</th>
                                    <th>Status</th>
                                    <th>Date</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>

                            <tbody>
                                {mockData.map((item) => (
                                    <tr key={item.id}>
                                        <td data-label="ID">{item.id}</td>
                                        <td data-label="Added By">
                                            <span>
                                                {item.user_details?.profile_photo_url ? 
                                                    <ImageShow url={item.user_details?.profile_photo_url} width={30} height={30} style={{ borderRadius: 50 }} /> : <UserOutlined />} {item.user_details?.display_name || 'N/A'}</span></td>
                                        <td data-label="Client"><CheckName data={item} /></td>
                                        <td data-label="Amount">₹{item.amount}</td>
                                        <td data-label="Transfer Type"><SwapOutlined /> {item.transactionType}</td>
                                        <td data-label="Income Type">
                                            <SwapOutlined /> {item.incomeType}
                                            {item.incomeType === 'invoice_payment' && (
                                                <div className="text-muted small">
                                                    Invoice Payment
                                                </div>
                                            )}
                                        </td>
                                        <td data-label="Description">
                                            <div className="text-truncate" style={{ maxWidth: '200px' }} title={item.description}>
                                                {item.description}
                                            </div>
                                            {item.incomeType === 'invoice_payment' && (
                                                <div className="text-muted small">
                                                    <CalendarOutlined /> {item.date ? item.date.split(' ')[0] : 'N/A'}
                                                </div>
                                            )}
                                        </td>
                                        <td data-label="Status"><Tag color={item.status === 'active' ? 'green' : 'red'}>{item.status}</Tag></td>
                                        <td data-label="Date">{item.date ? item.date.split(' ')[0] : 'N/A'}</td>
                                        <td data-label="Actions">
                                            <Space>
                                                <a className="dc-btn dc-update-general pt-0" data-id="4174" data-post="18128" onClick={() => handleEdit(item)} style={{ minWidth: 'auto' }}>
                                                    <EditOutlined style={{ color: '#1890ff' }} />
                                                </a>
                                                <a className="dc-btn dc-update-general pt-0" data-id="4174" data-post="18128" onClick={() => handleDelete(item)} style={{ minWidth: 'auto' }}>
                                                    <DeleteOutlined style={{ color: '#ff4d4f' }} />
                                                </a>
                                            </Space>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <Paginationnew currentPage={page} totalPages={total} handlePageChange={handlePageChange} />
                </div>
            </div>
        </div>
        
        {/* Add Income Modal */}
        <AddIncomeModel
            isOpen={isModalVisible}
            toggle={() => setIsModalVisible(false)}
            onSubmit={() => {}}
            fetchIncome={fetchIncome}
        />
        
        {/* Edit Income Modal */}
        <EditIncomModel
            isOpen={editIncomeModel}
            toggle={() => setEditIncomeModel(false)}
            getIncome={editIncome}
            fetchIncome={fetchIncome}
        />
        
        {/* Delete Confirmation Modal */}
        <ConfirmationModal
            show={isDeleteModalVisible}
            onHide={() => setIsDeleteModalVisible(false)}
            onConfirm={handleConfirmDelete}
            title="Delete Income Record"
            message="Are you sure you want to delete this income record? This action cannot be undone."
        />
    </div>
);
};

export default IncomeManagement; 
